import React from 'react'
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'

const NotAuthorized = () => {
    return <ErrorBoundary error={401} />
}

export default NotAuthorized